import React, { Component } from "react";
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

export default class NavigationBreadcrumbs extends Component {

    constructor(props){
        super(props);
        this.state = {
            main_title:this.props.main_title,
            main_route:this.props.main_route,
            current_title:this.props.current_title
        }
    }

    render(){return(
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href= {this.state.main_route} >
           {this.state.main_title}
          </Link>
        
          <Typography color="textPrimary">{this.state.current_title}</Typography>
        </Breadcrumbs>
    )}

}